import React, {  useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./LoginMenu.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { clearState } from './../features/User/UserSlice';
import { GoogleLogout } from 'react-google-login';
import URLstateContext from "../../provider/CommonContext";
import userarrowdown from "../../Images/user-arrowdown.png";
import orderreport from "../../Images/order-report.png";
import Avatar from 'react-avatar';
import tradelogin from "../../Images/trade-login.png";
import backoffice from "../../Images/back-office.png";
import helpsupport from "../../Images/help-support.png";
import imglogout from "../../Images/logout.png";
import { userSelector } from '../features/User/UserSlice';
import { FiLogOut, FiBookmark, FiSettings, FiHeadphones } from "react-icons/fi";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserAlt } from "@fortawesome/free-solid-svg-icons";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { faHeadphones } from "@fortawesome/free-solid-svg-icons";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";
function LoginMenu({ closeNav, username, email, imgurl, client_id, avatarimg }) {
    const {   isSuccess,   isCRMuser ,ProspectStage,mx_Lead_Status,mx_Status} = useSelector(
        userSelector
    );
    const User = <FontAwesomeIcon icon={faUserAlt} />
    const Users = <FontAwesomeIcon icon={faUsers} />
    const HeadPhones = <FontAwesomeIcon icon={faHeadphones} />
    const SignOut = <FontAwesomeIcon icon={faSignOut} />
    const { clientId } = useContext(URLstateContext);
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const onLogOut = () => {
        dispatch(clearState());
        localStorage.removeItem('token');
        window.location.reload(); 
    };
    // const onLogoutSuccess = (res) => {
    //    // console.log('Logged out Successfully:', res);
    //     localStorage.removeItem('token');
    //     dispatch(clearState());
    //     alert('Logged out Successfully ✌');
    //     window.location.reload();
    // }
    const onLogoutSuccess = (res) => {
        // console.log('Logged out Successfully:', res);
         window.google.accounts.id.disableAutoSelect();
         localStorage.removeItem('token');
         dispatch(clearState());
        //  alert('Logged out Successfully ✌');
        Swal.fire("Logged out Successfully ✌");
        navigate('/');
     }

    return (
        <>
            <div id="overlay" onClick={() => closeNav(false)}>
                <Container>
                    <Row>
                        <Col xs={12}>
                            <div className="user_profile">
                                
                                <div className="userprofile_dropdown ">
                                    <div className="userprofile_bio media">
                                        <div style={{ avatarimg: true ? 'block' : 'none' }} className="usernameimg_panel media">
                                            <span className="user_fname">{username != null ? username.substring(0, 1) : ''}</span>
                                            
                                        </div>
                                        <div className="user_nameemail media-body">
                                            <span className="userbio_name">{username}</span>
                                            <div className="user_email"><a href="#">{email}</a></div>
                                        </div>
                                    </div>
                                    <div style={{ display: isCRMuser ? 'none' : 'block' }} className="trading_ac">
                                        {
                                         ProspectStage=="Customer" &&mx_Lead_Status== "Active" && mx_Status== "Enabled"?<><p>Your Account is active</p></>:  
                                         ProspectStage=="Customer" &&mx_Lead_Status== "Ac Closed" && mx_Status== "Closed"?<><p>Your acount closed please reopen acount</p><a href="https://kyc.moneysukh.com/" className="common_btn w-100">Complete your Setup</a></>:
                                         ProspectStage=="Customer" &&mx_Lead_Status== "Inactive" && mx_Status== "Disabled"?<><p>Your Account need re-active</p>
                                        </>: <><p>Your Account is not active yet</p>
                                        <a href="https://kyc.moneysukh.com/" className="common_btn w-100">Complete your Setup</a></>
                                        }
                                    </div>
                                    <div className="userprofile_biogrid">
                                        {/* <ul className="userprofile_biolist">
                                            <li>
                                                <a target="_blank" href="https://online.moneysukh.com/">
                                                    <span className="userprfl_bioicon">
                                                        <img src={tradelogin} className="orderreport" />
                                                    </span>
                                                    <span className="userprfl_biotext">Trade Login</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a target="_blank" href="https://backoffice.moneysukh.com:8080/capexweb/capexweb/">
                                                    <span className="userprfl_bioicon">
                                                        <img src={backoffice} className="orderreport" />
                                                    </span>
                                                    <span className="userprfl_biotext">Back office Login</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a target="_blank" href="https://support.moneysukh.com/">
                                                    <span className="userprfl_bioicon">
                                                        <img src={helpsupport} className="orderreport" />
                                                    </span>
                                                    <span className="userprfl_biotext">Help & Support</span>
                                                </a>
                                            </li>
                                            <li>
                                                <span className="userprfl_bioicon">
                                                    <img src={imglogout} className="orderreport" />
                                                </span>
                                                <span className="userprfl_biotext">
                                                   
                                                    <button className="googlebutton" onClick={onLogoutSuccess}>Logout</button>
                                                </span>
                                            </li>
                                        </ul> */}
                                        {
ProspectStage=="Dropped" || ProspectStage=="Sales Qualified Lead"|| ProspectStage=="Prospect"?<>
<ul className="userprofile_biolist">
                                           
                                            <li>
                                                <a target="_blank" href="https://support.moneysukh.com/">
                                                    <span className="userprfl_bioicon">
                                                        
                                                        <i>{HeadPhones}</i>
                                                    </span>
                                                    <span className="userprfl_biotext">Help & Support</span>
                                                </a>
                                            </li>
                                            <li>
                                                <span className="userprfl_bioicon">
                                                    
                                                    <i>{SignOut}</i>
                                                </span>
                                                <span className="userprfl_biotext">
                                                   
                                                    <button className="googlebutton" onClick={onLogoutSuccess}>Logout</button>
                                                </span>
                                            </li>
                                        </ul>
</>:ProspectStage=="Customer" &&mx_Lead_Status== "Active" && mx_Status== "Enabled"?<>
<ul className="userprofile_biolist">
                                            <li>
                                                <a target="_blank" href="https://online.moneysukh.com/">
                                                    <span className="userprfl_bioicon">
                                                       
                                                        <i>{User}</i>
                                                    </span>
                                                    <span className="userprfl_biotext">Trade Login</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a target="_blank" href="https://backoffice.moneysukh.com:8080/capexweb/capexweb/">
                                                    <span className="userprfl_bioicon">
                                                       
                                                        <i>{Users}</i>
                                                    </span>
                                                    <span className="userprfl_biotext">Back office Login</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a target="_blank" href="https://support.moneysukh.com/">
                                                    <span className="userprfl_bioicon">
                                                        
                                                        <i>{HeadPhones}</i>
                                                    </span>
                                                    <span className="userprfl_biotext">Help & Support</span>
                                                </a>
                                            </li>
                                            <li>
                                                <span className="userprfl_bioicon">
                                                    
                                                    <i>{SignOut}</i>
                                                </span>
                                                <span className="userprfl_biotext">
                                                   
                                                    <button className="googlebutton" onClick={onLogoutSuccess}>Logout</button>
                                                </span>
                                            </li>
                                        </ul>
                                        </>:
ProspectStage=="Customer" &&mx_Lead_Status== "Ac Closed" && mx_Status== "Closed"?<>
<ul className="userprofile_biolist">
                                           
                                            <li>
                                                <a target="_blank" href="https://online.moneysukh.com/">
                                                    <span className="userprfl_bioicon">
                                                        
                                                        <i>{HeadPhones}</i>
                                                    </span>
                                                    <span className="userprfl_biotext">Re-open Account</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a target="_blank" href="https://support.moneysukh.com/">
                                                    <span className="userprfl_bioicon">
                                                        
                                                        <i>{HeadPhones}</i>
                                                    </span>
                                                    <span className="userprfl_biotext">Help & Support</span>
                                                </a>
                                            </li>
                                            <li>
                                                <span className="userprfl_bioicon">
                                                    
                                                    <i>{SignOut}</i>
                                                </span>
                                                <span className="userprfl_biotext">
                                                   
                                                    <button className="googlebutton" onClick={onLogoutSuccess}>Logout</button>
                                                </span>
                                            </li>
                                        </ul></>:
ProspectStage=="Customer" &&mx_Lead_Status== "Inactive" && mx_Status== "Disabled"?<>
<ul className="userprofile_biolist">
                                           
                                            <li>
                                                <a target="_blank" href="https://rekyc.moneysukh.com:9443/directpan.aspx">
                                                    <span className="userprfl_bioicon">
                                                        
                                                        <i>{HeadPhones}</i>
                                                    </span>
                                                    <span className="userprfl_biotext">Re-Active Account</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a target="_blank" href="https://support.moneysukh.com/">
                                                    <span className="userprfl_bioicon">
                                                        
                                                        <i>{HeadPhones}</i>
                                                    </span>
                                                    <span className="userprfl_biotext">Help & Support</span>
                                                </a>
                                            </li>
                                            <li>
                                                <span className="userprfl_bioicon">
                                                    
                                                    <i>{SignOut}</i>
                                                </span>
                                                <span className="userprfl_biotext">
                                                   
                                                    <button className="googlebutton" onClick={onLogoutSuccess}>Logout</button>
                                                </span>
                                            </li>
                                        </ul></>:
                                        <>
<ul className="userprofile_biolist">
                                           
                                            <li>
                                                <a target="_blank" href="https://support.moneysukh.com/">
                                                    <span className="userprfl_bioicon">
                                                        
                                                        <i>{HeadPhones}</i>
                                                    </span>
                                                    <span className="userprfl_biotext">Help & Support</span>
                                                </a>
                                            </li>
                                            <li>
                                                <span className="userprfl_bioicon">
                                                    
                                                    <i>{SignOut}</i>
                                                </span>
                                                <span className="userprfl_biotext">
                                                   
                                                    <button className="googlebutton" onClick={onLogoutSuccess}>Logout</button>
                                                </span>
                                            </li>
                                        </ul>
</>

                                        }
                                        
                                    </div>
                                </div>
                            </div>
                            
                        </Col>                       
                    </Row>                    
                </Container>
            </div>
        </>
    );
}
export default LoginMenu;
